
import moment from 'moment';

// XXX: `moment.ISO_8601` can backfire: https://github.com/moment/moment/issues/3019
export const read = s => moment(s, moment.ISO_8601);
export const write = m => m && m.toISOString();
export const momentViewExtend = { view: { moment: { read, write } } };